// extracted by mini-css-extract-plugin
export default {"date":"QfuZiA12ftQhlfDA94bp"};